import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/core/Button';
import { ViewMapButton } from 'components/search/ViewMapButton';
import { Filters } from 'components/svg';

import './FiltersAndMap.scss';

export function FiltersAndMap({ openFilters, openMap }) {
	return (
		<div className="filters-and-map">
			<Button
				onClick={openFilters}
				outline
			>
				<Filters />
				Filters
			</Button>
			<ViewMapButton onClick={openMap} text="View Map" />
		</div>
	);
}

FiltersAndMap.propTypes = {
	openFilters: PropTypes.func,
	openMap: PropTypes.func
};

export default FiltersAndMap;
